<template>
  <div class="selectGrop solveBfc pointer">
    <NavBar title="选择转移设备" />
    <div class="contentBox" v-if="isExist || loading">
      <div class="card" v-for="(item, index) in cardList" :key="item.id">
        <div class="information">
          <div class="mationLeft" @click.stop="unfold(index)">
            <div class="nameTop">
              <div class="groupNameBox">
                <div>
                  {{ item.groupName }}
                </div>
                <div class="numBottom">共{{ item.instanceList.length }}台</div>
              </div>
              <img
                v-show="item.showStatus"
                src="../../../assets/imgs/groupingTop.png"
                alt=""
              />
              <img
                v-show="!item.showStatus"
                src="../../../assets/imgs/groupingBottom.png"
                alt=""
              />
            </div>
          </div>
          <div class="mationRight">
            <van-checkbox
              v-model="item.result"
              ref="checkboxGroup"
              @click="checkAllMember(index, item.result)"
              :disabled="item.instanceList.length > 0 ? false : true"
              checked-color="#8572eb"
            ></van-checkbox>
          </div>
        </div>
        <div
          class="listEquipment"
          v-show="item.showStatus && item.instanceList.length > 0"
        >
          <van-checkbox-group
            v-model="result"
            :ref="'checkboxes' + index"
            @change="checkchange(item, index)"
          >
            <van-cell-group :border="false">
              <van-cell
                v-for="(list, index1) in item.instanceList"
                :key="list.id"
                clickable
                @click.stop="toggle(index, index1)"
                :border="false"
                class="cellItem"
              >
                <template #title>
                  <div class="shebei_title">
                    <div class="shebei_content">
                      <p class="p1">
                        <span class="deviceType">{{
                          getDeviceType(list.vipCode, list.deviceVersionCode)
                        }}</span>
                        {{ list.instanceName }}
                      </p>
                      <div class="p2">
                        <img class="idIcon" src="@/assets/imgs/ID.png" alt="" />
                        <p class="id">{{ list.instanceId }}</p>
                      </div>
                    </div>
                    <div class="instanceItem">
                      剩余时间：{{ formatSeconds(list.expireSeconds) }}
                    </div>
                  </div>
                </template>
                <template #right-icon>
                  <van-checkbox
                    :name="list"
                    :ref="'checkboxes' + index + index1"
                    checked-color="#8572eb"
                  />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
      </div>
    </div>
    <van-empty
      v-else
      class="custom-image"
      :image="require('@/assets/imgs/empty.png')"
      description="暂时没有可转移的云手机哦！"
    />
    <div class="base">
      <div class="baseText">已选择{{ result.length }}台设备</div>
      <button class="baseBut button" @click="movement">确定</button>
    </div>
    <Loading v-model="loading" text="加载中..."> </Loading>
  </div>
</template>
        
  <script>
import { Toast } from "vant";
import NavBar from "@/components/NavBar.vue";
import { groupList, rename } from "@/api/index";
import { mapState, mapMutations } from "vuex";
import buyCode from "@/utils/buyCode";
import Loading from "@/components/publicDialog/Loading.vue";
export default {
  name: "ChoiceDevice",
  components: {
    NavBar,
    Loading,
  },
  data() {
    return {
      cardList: [],
      operate: null,
      result: [],
      isExist: false,
      loading: false,
    };
  },
  mounted() {
    this.getGroupList();
    this.operate = this.$route.query.operate;
    // this.result = this.transferEquipmentList;
  },
  computed: {
    //数组写法
    ...mapState("common", ["transferEquipmentList"]),
    getDeviceType: {
      get() {
        return function (vipCode, deviceVersionCode) {
          let item = buyCode.deviceIconOptions.find(
            (item) =>
              item.vipCode == vipCode &&
              item.deviceVersionCode == deviceVersionCode
          );
          if (item) {
            return item.deviceType;
          } else {
            if (deviceVersionCode) {
              return `定制${deviceVersionCode.substring(1)}`;
            } else {
              return "";
            }
          }
        };
      },
    },
  },
  beforeDestroy() {},
  methods: {
    ...mapMutations("common", ["SET_TEANSFEREQUIPMENTLIST"]),
    // 获取分组信息
    getGroupList() {
      this.loading = true;
      groupList()
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            for (let i = 0; i < res.data.length; i++) {
              res.data[i].showStatus = false;
              res.data[i].result = false;
            }
            let arr = res.data;
            this.cardList = JSON.parse(JSON.stringify(arr));
            for (let i = 0; i < arr.length; i++) {
              const filterItems = arr[i].instanceList.filter(function (it) {
                return (
                  it.isAuthorized == 0 &&
                  it.overSoldDevice == false &&
                  // it.isTransferable == 0 &&
                  it.expireSeconds > 24 * 60 * 60 &&
                  it.maintenanceStatus == 0
                );
              });
              if (filterItems.length > 0) {
                this.isExist = true;
              }
              this.cardList[i].instanceList = filterItems;
            }
            for (let i = 0; i < this.cardList.length; i++) {
              for (let k = 0; k < this.cardList[i].instanceList.length; k++) {
                for (let j = 0; j < this.transferEquipmentList.length; j++) {
                  if (
                    this.cardList[i].instanceList[k].id ==
                    this.transferEquipmentList[j].id
                  ) {
                    this.$nextTick(function () {
                      this.$refs["checkboxes" + i + k][0].toggle(true);
                    });
                    res.data[i].showStatus = true;
                  }
                }
              }
            }
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    // 确定按钮
    movement() {
      if (this.result.length > 10) {
        Toast("一次性选择的设备不能超过10台");
      } else if (this.result.length > 0) {
        this.SET_TEANSFEREQUIPMENTLIST(this.result);
        this.$router.go(-1);
      } else {
        Toast("请选择设备");
      }
    },
    // 小选择
    toggle(index, index1) {
      if (this.cardList[index].result == true) {
        this.cardList[index].result = false;
      }
      this.$refs["checkboxes" + index + index1][0].toggle();
    },
    // 小项全选，大项自动勾选
    checkchange(item, index) {
      let checkResult = this.$refs["checkboxes" + index][0].$children.every(
        (item) => item.checked
      );
      if (checkResult) {
        if (this.cardList[index].result == false) {
          this.cardList[index].result = true;
        }
      }
    },
    // 全选，全不选
    checkAllMember(index, type) {
      // this.$refs.checkboxGroup
      // this.$refs["checkboxes" + index][0].toggleAll(type);
      if (type) {
        for (
          let i = 0;
          i < this.$refs["checkboxes" + index][0].$children.length;
          i++
        ) {
          this.$refs["checkboxes" + index][0].$children[i].checked = true;
          this.$refs["checkboxes" + index][0].$children[i].toggle(type);
        }
      } else {
        for (
          let i = 0;
          i < this.$refs["checkboxes" + index][0].$children.length;
          i++
        ) {
          this.$refs["checkboxes" + index][0].$children[i].checked = false;
          this.$refs["checkboxes" + index][0].$children[i].toggle(type);
        }
      }
    },
    // 展开收起
    unfold(index) {
      this.cardList[index].showStatus = !this.cardList[index].showStatus;
    },
    formatSeconds(totalSeconds) {
      // 计算各时间单位
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      // 生成单位映射
      const units = ["天", "小时", "分"];
      // 构建结果数组
      const parts = [];
      if (days > 0) parts.push(`${days}${units[0]}`);
      if (hours > 0) parts.push(`${hours}${units[1]}`);
      if (minutes > 0 && totalSeconds < 86400)
        parts.push(`${minutes}${units[2]}`);
      // 处理全0情况
      if (parts.length === 0) return `0${units[3]}`;
      return parts.join("");
    },
  },
};
</script>
        
  <style lang="less" scoped>
.defaultGraphImg {
  width: 160px;
  height: 160px;
}
.van-cell {
  padding: 12px 0;
}
.button {
  border: none;
  background: none;
}
.selectGrop {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
}

.contentBox {
  padding: 0 10px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation;
  scrollbar-width: none;
  padding-bottom: 20px;
  .card {
    margin-top: 10px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 14px 0px 14px 0px;
    border-radius: 10px;
    .information {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 4px 16px;
      .mationLeft {
        width: 90%;
        .nameTop {
          display: flex;
          font-size: 17px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          color: #333333;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .groupNameBox {
            display: flex;
            align-items: center;
            .numBottom {
              font-size: 13px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              color: #999999;
              text-align: left;
              margin-left: 8px;
            }
          }
          img {
            width: 20px;
            margin-top: 2px;
          }
        }
      }
      .mationRight {
        // height: 24px;
        img {
          width: 24px;
        }
        .rightImg1 {
          margin-right: 12px;
        }
      }
    }
    .listEquipment:before {
      content: "";
      width: 319px;
      border: 1px solid #f5f7fb;
      height: 0px;
      position: absolute;
      top: -4px;
      left: 50%;
      transform: translateX(-50%);
    }
    .listEquipment {
      position: relative;
      margin-top: 17px;
      .listNape {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 64px;
      }
      .cellItem {
        border-radius: 12px;
        padding: 6px 16px 6px 16px;
      }
    }
  }
  .shebei_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
    }
    .shebei_content {
      // margin-left: 16px;
      text-align: left;
      p {
        margin: 0;
        height: 22px;
        font-size: 13px;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
      }
      .p1 {
        font-weight: 500;
        font-size: 15px;
        color: #505465;
      }
      .p2 {
        display: flex;
        align-items: center;
        .idIcon {
          width: 18px;
          height: 17px;
          margin-right: 4px;
        }
        .id {
          font-weight: 500;
          font-size: 10px;
          color: #b8bdcc;
        }
      }
    }
    .instanceItem {
      font-weight: 400;
      font-size: 13px;
      color: #a9adb6;
    }
  }
  .check {
    margin-right: 2px;
  }
}
.base {
  width: 100%;
  height: 60px;
  background: #ffffff;
  box-shadow: 0px -1px 2px 0px rgba(153, 153, 153, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 14px;
  .baseText {
    font-size: 15px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #666;
  }
  .baseBut {
    width: 120px;
    height: 44px;
    background: #886df3;
    border-radius: 26px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
  }
}
.TitleBox {
  position: relative;
  img {
    width: 16px;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translate(-50%, -50%);
  }
}
.deleteTitle {
  font-size: 16px;
  font-weight: 400;
  color: #000;
  margin-top: 16px;
}
.hintText {
  font-size: 14px;
  font-weight: 400;
  color: #666;
  margin-top: 26px;
  padding: 0 24px;
}
.deleteOperate {
  margin: 38px auto 20px auto;
  .deleteCancel {
    width: 116px;
    height: 40px;
    background: #edeff3;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #9b9b9b;
    margin-right: 16px;
    line-height: 40px;
  }
  .deleteAffirm {
    width: 116px;
    height: 40px;
    background: #558bff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    line-height: 40px;
  }
  .machineCancel {
    width: 25%;
    height: 30px;
    background: #edeff3;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #9b9b9b;
    line-height: 30px;
  }
  .machineAffirm {
    width: 25%;
    height: 34px;
    background: #558bff;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    line-height: 30px;
    margin-left: 12px;
  }
  .gram {
    background: #aaacb5;
  }
}
.wire {
  height: 1px;
  width: 85%;
  background-color: #f0ebeb;
  margin: 0 auto;
}
.blue {
  background-color: #558bff;
}
.van-cell::after {
  display: none;
}
/deep/ .van-field__control {
  // width: 315px;
  height: 40px;
  // background: #f5f5f5;
  // border-radius: 8px;
  // border: 1px solid #ebebeb;
  // margin: 24px auto 0 auto;
  // text-indent: 16px;
}
/deep/.van-tabs__wrap {
  display: block !important;
  padding-bottom: 18px;
}
/deep/.van-cascader__options {
  padding-top: 0;
}
/deep/.van-cascader__options {
  height: 300px;
}
.picker_toolbar {
  display: flex;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  height: 44px;
}
.picker_cancel {
  height: 100%;
  padding: 0 16px;
  font-size: 14px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.picker_confirm {
  height: 100%;
  padding: 0 16px;
  font-size: 14px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #576b95;
}
.picker_title {
  max-width: 50%;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
}
/deep/.van-search__content--round {
  height: 40px;
}
/deep/.van-field__body {
  height: 20px !important;
}
/deep/.van-icon-search {
  margin-top: -2px;
}
</style>